import { createFileRoute, Outlet } from "@tanstack/react-router";
import { OrganisationLayout } from "~/pages/settings/organisations/organisation/organisation-layout";

export const Route = createFileRoute(
  "/_app/settings/organisations/$organisationId",
)({
  component: OrganisationRoute,
});

function OrganisationRoute() {
  const { organisationId } = Route.useParams();

  return (
    <OrganisationLayout organisationId={organisationId}>
      <Outlet />
    </OrganisationLayout>
  );
}
